<template>
  <Header />
  <Blogs />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Blogs from "@/components/Blogposts/TimeSeriesBlogs.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Blogs,
    Footer,
  },
};
</script>
